import Shell from "@shared/Shell";
import Tabs from "@shared/Tabs";
import DealerPayments from "@components/DealerPayments";
import DealerManagement from "@components/DealerManagement";

export function Dealers() {

  const tabs = [
    { label: "Payments", child: <DealerPayments /> },
    { label: "Manage Dealers", child: <DealerManagement /> },
  ];

  return (
    <Shell pageIndex={1}>
      <Tabs tabs={tabs} defaultIndex={0} />
    </Shell>
  );
}

export default Dealers;
